import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import Firebase from 'firebase'
import Cache from '@/services/Cache'
import Assinatura from '@/services/Assinatura'

import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout'
// GeneralViews
import NotFound from '@/components/GeneralViews/NotFoundPage'
import VerifyEmail from '@/components/GeneralViews/VerifyEmail'
import ResetPassword from '@/components/GeneralViews/ResetPassword'
import Login from '@/components/Dashboard/Views/Pages/Login'
import Register from '@/components/Dashboard/Views/Pages/Register'
import UserProfile from '@/components/Dashboard/Views/Pages/UserProfile'
import Assinaturas from '@/components/Dashboard/Views/Admin/Assinaturas'
import Simulacoes from './simulacoes'
import Relatorios from './relatorios'

if (!Cache.disponivel('localStorage')) {
  // TODO - Throw erro na tela e não deixa continuar
  console.error('Não é possivel acessar o cache!')
}

Vue.use(VueRouter)

const routes = [
  {
    name: 'dashboard',
    path: '/',
    component: DashboardLayout,
    redirect: '/simulacoes/listar',
    children: Simulacoes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/relatorios',
    name: 'relatorios',
    component: DashboardLayout,
    redirect: '/consolidado/listar',
    children: Relatorios,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/meu-perfil',
    component: DashboardLayout,
    children: [
      {
        name: 'meu-perfil',
        path: '/meu-perfil',
        component: UserProfile
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/assinaturas',
    component: DashboardLayout,
    children: [
      {
        name: 'assinaturas',
        path: '/admin/assinaturas',
        component: Assinaturas
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'entrar',
    path: '/entrar',
    component: Login
  },
  {
    name: 'cadastrar',
    path: '/cadastrar',
    component: Register
  },
  {
    name: 'verifica-email',
    path: '/verificar-email',
    component: VerifyEmail
  },
  {
    name: 'redefinicao-senha',
    path: '/redefinicao-senha',
    component: ResetPassword
  },
  {
    name: 'auth',
    path: '/auth',
    beforeEnter: (to, from, next) => {
      if (!to || !to.query) {
        next({ name: 'entrar' })
      } else if (to.query.mode === 'resetPassword') {
        next({ name: 'redefinicao-senha', query: to.query })
      } else if (to.query.mode === 'verifyEmail') {
        next({ name: 'verifica-email', query: to.query })
      } else {
        next({ name: 'entrar' })
      }
    }
  },
  {
    path: '*',
    component: NotFound
  }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '');
   return res;
};**/

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

Vue.use(VueAnalytics, {
  id: 'UA-113655402-1',
  router,
  autoTracking: {
    transformQueryString: false
  },
  debug: {
    enabled: false // é bem pesado, só ativar quando necessário
  }
})

router.beforeEach((to, from, next) => {
  const currentUser = Firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  Assinatura.buscar().then(assinatura => {
    if (requiresAuth && !currentUser) {
      next({ name: 'entrar' })
    } else if (!requiresAuth && currentUser) {
      next({ name: 'dashboard' })
    } else {
      next()
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/routes/index.js